import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    { staticClass: "mx-md-5 mx-2" },
    [
      _c(
        VExpansionPanels,
        {
          model: {
            value: _vm.showSettings,
            callback: function ($$v) {
              _vm.showSettings = $$v
            },
            expression: "showSettings",
          },
        },
        [
          _c(
            VExpansionPanel,
            [
              _c(
                VExpansionPanelHeader,
                { staticClass: "d-flex justify-space-between" },
                [
                  _c("div", { staticClass: "d-flex flex-column flex-md-row" }, [
                    _c("span", { staticClass: "mb-2 mb-md-0" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$vuetify.lang.t(
                            "$vuetify.summary.reportParameters"
                          )
                        )
                      ),
                    ]),
                    _vm.showSettings != 0
                      ? _c(
                          "span",
                          {
                            class: `ml-0 ml-md-5 ${
                              _vm.isMobile ? "text-caption" : ""
                            }`,
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("formatDateYear")(
                                    _vm.parameters.startDate
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("formatDateYear")(
                                    _vm.parameters.endDate
                                  )
                                )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm.showSettings != 0 && !_vm.loadingData
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-end mr-2 mr-md-10" },
                        [
                          _vm.isMobile
                            ? _c(
                                VBtn,
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.download.apply(null, arguments)
                                    },
                                  },
                                },
                                [_c(VIcon, [_vm._v("mdi-download")])],
                                1
                              )
                            : _c(
                                VBtn,
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.download.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.base.download"
                                      )
                                    ) + " "
                                  ),
                                  _c(VIcon, { attrs: { right: "" } }, [
                                    _vm._v("mdi-download"),
                                  ]),
                                ],
                                1
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                VExpansionPanelContent,
                [
                  _c(
                    VSheet,
                    [
                      _c("search-parameters", {
                        model: {
                          value: _vm.parameters,
                          callback: function ($$v) {
                            _vm.parameters = $$v
                          },
                          expression: "parameters",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            VBtn,
                            {
                              attrs: {
                                disabled: _vm.loadingData,
                                loading: _vm.loadingData,
                                color: "primary",
                              },
                              on: { click: _vm.clickSubmit },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$vuetify.lang.t("$vuetify.base.submit")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VSheet,
        { staticClass: "mt-5", attrs: { elevation: 2 } },
        [
          _vm.loadingData
            ? _c(VProgressLinear, {
                attrs: { indeterminate: "", color: "accent" },
              })
            : _vm._e(),
          _vm.isMobile && !_vm.loadingData
            ? _c(VTextField, {
                staticClass: "mx-5 pt-5",
                attrs: { clearable: "", label: "Filter by Name" },
                model: {
                  value: _vm.filterProduct,
                  callback: function ($$v) {
                    _vm.filterProduct = $$v
                  },
                  expression: "filterProduct",
                },
              })
            : _vm._e(),
          !_vm.loadingData && _vm.startBalanceService.date
            ? _c(
                VSimpleTable,
                {
                  staticStyle: { "table-layout": "fixed" },
                  attrs: { id: "main-table", height: "90vh" },
                },
                [
                  _c("date-tree-header", {
                    attrs: {
                      startDate: _vm.parameters.startDate,
                      endDate: _vm.parameters.endDate,
                      prefix: ["Program"],
                      postfix: [],
                      hideExpanableColumns: !_vm.displays.showEvents,
                      sticky: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "before",
                          fn: function ({ dateHeaders }) {
                            return [
                              _c(
                                "th",
                                {
                                  staticStyle: { "z-index": "4" },
                                  attrs: {
                                    rowspan:
                                      dateHeaders && dateHeaders.length > 0
                                        ? dateHeaders.length
                                        : 1,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between",
                                    },
                                    [
                                      !_vm.isMobile
                                        ? _c(VTextField, {
                                            staticClass: "mr-2 mr-md-5",
                                            staticStyle: {
                                              "min-width": "125px",
                                            },
                                            attrs: {
                                              clearable: "",
                                              label: "Filter by Name",
                                            },
                                            model: {
                                              value: _vm.filterProduct,
                                              callback: function ($$v) {
                                                _vm.filterProduct = $$v
                                              },
                                              expression: "filterProduct",
                                            },
                                          })
                                        : _vm._e(),
                                      _c("display-filter", {
                                        staticClass: "mt-4",
                                        model: {
                                          value: _vm.displays,
                                          callback: function ($$v) {
                                            _vm.displays = $$v
                                          },
                                          expression: "displays",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "th",
                                {
                                  staticStyle: { "z-index": "3" },
                                  attrs: {
                                    rowspan:
                                      dateHeaders && dateHeaders.length > 0
                                        ? dateHeaders.length
                                        : 1,
                                  },
                                },
                                [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g(
                                                    _vm._b(
                                                      {},
                                                      "span",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatDateYear"
                                                        )(
                                                          _vm
                                                            .startBalanceService
                                                            .date
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Inventory balance at the start of " +
                                            _vm._s(
                                              _vm._f("formatDateYear")(
                                                _vm.startBalanceService.date
                                              )
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "after",
                          fn: function ({ dateHeaders }) {
                            return [
                              _c(
                                "th",
                                {
                                  attrs: {
                                    rowspan:
                                      dateHeaders && dateHeaders.length > 0
                                        ? dateHeaders.length
                                        : 1,
                                  },
                                },
                                [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g(
                                                    _vm._b(
                                                      {},
                                                      "span",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatDateYear"
                                                        )(
                                                          _vm.endBalanceService
                                                            .date
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Inventory balance at the end of " +
                                            _vm._s(
                                              _vm._f("formatDateYear")(
                                                _vm.endBalanceService.date
                                              )
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      129647682
                    ),
                    model: {
                      value: _vm.openDates,
                      callback: function ($$v) {
                        _vm.openDates = $$v
                      },
                      expression: "openDates",
                    },
                  }),
                  _c(
                    "tbody",
                    [
                      _c(
                        "tr",
                        [
                          _c(
                            "td",
                            { on: { click: _vm.openCloseAllProducts } },
                            [
                              _vm.showProductGroup
                                ? _c(VIcon, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.openAllState == "open"
                                            ? "mdi-chevron-double-down"
                                            : "mdi-chevron-double-right"
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" All Products "),
                            ],
                            1
                          ),
                          _c("td", { staticClass: "currency" }, [
                            _vm.displays.unit == "value"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.startBalanceService.totalValue
                                        )
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.startBalanceService.totalQuantity
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                          _vm._l(_vm.openDates, function (range) {
                            return _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.displays.showEvents,
                                    expression: "displays.showEvents",
                                  },
                                ],
                                key:
                                  _vm.submitTime +
                                  "_" +
                                  _vm.allProduct.id +
                                  "_" +
                                  range.id,
                                staticClass: "event-cell",
                              },
                              [
                                _c("inventory-event", {
                                  key:
                                    _vm.submitTime +
                                    "_" +
                                    _vm.allProduct.id +
                                    "_" +
                                    range.id,
                                  attrs: {
                                    display: _vm.displays.unit,
                                    product: _vm.allProduct,
                                    dateRange: range,
                                  },
                                  on: {
                                    clickViewDetails: function ($event) {
                                      return _vm.viewCellDetails(
                                        _vm.allProduct,
                                        range
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          _c("td", [
                            _vm.displays.unit == "value"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.endBalanceService.totalValue
                                        )
                                      ) +
                                      " "
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.endBalanceService.totalQuantity
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]),
                        ],
                        2
                      ),
                      _vm._l(_vm.products, function (product) {
                        return [
                          product.visible
                            ? _c(
                                "tr",
                                { key: product.id, staticClass: "product" },
                                [
                                  _c("td", { staticClass: "product-name" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-space-between",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class:
                                              "product-name mt-2 ml-" +
                                              (product.level - 1) * 2,
                                          },
                                          [
                                            product.hasChildren
                                              ? _c(
                                                  VIcon,
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleProductGroup(
                                                          product
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          product.state ==
                                                            "open"
                                                            ? "mdi-chevron-down"
                                                            : "mdi-chevron-right"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.filterProduct
                                              ? _c(
                                                  "text-highlight",
                                                  {
                                                    attrs: {
                                                      queries:
                                                        _vm.filterProduct,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(product.name)
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [
                                                  _vm._v(
                                                    " " + _vm._s(product.name)
                                                  ),
                                                ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          VMenu,
                                          {
                                            attrs: {
                                              right: "",
                                              "offset-x": "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        _vm._g(
                                                          _vm._b(
                                                            {},
                                                            "div",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            VBtn,
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                            },
                                                            [
                                                              _c(VIcon, [
                                                                _vm._v(
                                                                  "mdi-dots-vertical"
                                                                ),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              VList,
                                              {
                                                staticClass: "px-2",
                                                attrs: {
                                                  dense: "",
                                                  "min-width": "150px",
                                                },
                                              },
                                              [
                                                _c(
                                                  VListItemGroup,
                                                  [
                                                    _c(
                                                      VListItem,
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.generateChart(
                                                              product
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          VListItemIcon,
                                                          [
                                                            _c(VIcon, [
                                                              _vm._v(
                                                                "mdi-chart-line"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          VListItemContent,
                                                          [
                                                            _c(
                                                              VListItemTitle,
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    product.name
                                                                  ) + " Chart"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c("td", { staticClass: "start-balance" }, [
                                    _vm.startBalanceService
                                      ? _c(
                                          "a",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.showInventoryList(
                                                  product,
                                                  _vm.startBalanceService
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.displays.unit == "value"
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("currency")(
                                                        _vm.startBalanceService.getBalanceByProduct(
                                                          product
                                                        ).remainingValue
                                                      )
                                                    ) + " "
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          _vm.startBalanceService.getBalanceByProduct(
                                                            product
                                                          ).quantity
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._l(_vm.openDates, function (range) {
                                    return _c(
                                      "td",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.displays.showEvents,
                                            expression: "displays.showEvents",
                                          },
                                        ],
                                        key:
                                          _vm.submitTime +
                                          "_" +
                                          product.id +
                                          "_" +
                                          range.id,
                                        staticClass: "event-cell",
                                      },
                                      [
                                        product.visible
                                          ? _c("inventory-event", {
                                              key:
                                                _vm.submitTime +
                                                "_" +
                                                product.id +
                                                "_" +
                                                range.id,
                                              attrs: {
                                                display: _vm.displays.unit,
                                                product: product,
                                                dateRange: range,
                                              },
                                              on: {
                                                clickViewDetails: function (
                                                  $event
                                                ) {
                                                  return _vm.viewCellDetails(
                                                    product,
                                                    range
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }),
                                  _c("td", { staticClass: "end-balance" }, [
                                    _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showInventoryList(
                                              product,
                                              _vm.endBalanceService
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.displays.unit == "value"
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      _vm.endBalanceService.getBalanceByProduct(
                                                        product
                                                      ).remainingValue
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("formatNumber")(
                                                      _vm.endBalanceService.getBalanceByProduct(
                                                        product
                                                      ).quantity
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                      ]
                                    ),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.selectedSlot
            ? _c(
                "custom-dialog",
                {
                  attrs: { fullscreen: true },
                  model: {
                    value: _vm.showDetails,
                    callback: function ($$v) {
                      _vm.showDetails = $$v
                    },
                    expression: "showDetails",
                  },
                },
                [
                  _c("template", { slot: "title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.selectedSlot.product) +
                        " " +
                        _vm._s(
                          _vm.isMobile
                            ? ""
                            : "- Inventory Events on " +
                                _vm.selectedDateRange.label
                        ) +
                        " "
                    ),
                  ]),
                  _c("template", { slot: "subtitle" }, [
                    _vm.isMobile
                      ? _c("div", [
                          _vm._v(
                            " Inventory Events on " +
                              _vm._s(_vm.selectedDateRange.label) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "template",
                    { slot: "default" },
                    [
                      _c("inventory-events-detail", {
                        key: _vm.clickTime + "-" + _vm.selectedSlot.key,
                        attrs: {
                          summaryByProductTime: _vm.selectedSlot,
                          date: _vm.selectedDateRange.endTime,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm.selectedProduct
            ? _c(
                "custom-dialog",
                {
                  attrs: { fullscreen: true },
                  model: {
                    value: _vm.inventoryListDialog,
                    callback: function ($$v) {
                      _vm.inventoryListDialog = $$v
                    },
                    expression: "inventoryListDialog",
                  },
                },
                [
                  _vm.isMobile
                    ? _c("template", { slot: "title" }, [
                        _vm._v(" " + _vm._s(_vm.selectedProduct.product) + " "),
                      ])
                    : _c("template", { slot: "title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.selectedProduct.product) +
                            " - Inventory balance on " +
                            _vm._s(_vm._f("formatDateYear")(_vm.selectedDate)) +
                            " "
                        ),
                      ]),
                  _vm.isMobile
                    ? _c("template", { slot: "subtitle" }, [
                        _vm._v(
                          " Inventory balance on " +
                            _vm._s(_vm._f("formatDateYear")(_vm.selectedDate)) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "template",
                    { slot: "default" },
                    [
                      _c("inventory-balance", {
                        key: _vm.clickTime + "_" + _vm.selectedProduct.id,
                        attrs: {
                          summaryByProductTime: _vm.selectedProduct,
                          date: _vm.selectedDate,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm.selectedProduct
            ? _c(
                "custom-dialog",
                {
                  attrs: { fullscreen: true },
                  model: {
                    value: _vm.productChartDialog,
                    callback: function ($$v) {
                      _vm.productChartDialog = $$v
                    },
                    expression: "productChartDialog",
                  },
                },
                [
                  _c("template", { slot: "title" }, [
                    _vm._v(
                      " " + _vm._s(_vm.selectedProduct.name) + " - Chart "
                    ),
                  ]),
                  _c(
                    "template",
                    { slot: "default" },
                    [
                      _c("date-distribution-chart", {
                        key:
                          _vm.clickTime +
                          "_" +
                          _vm.selectedProduct.id +
                          "_" +
                          _vm.openDates.length,
                        attrs: {
                          product: _vm.selectedProduct,
                          dates: _vm.openDates,
                        },
                        on: {
                          "update:product": function ($event) {
                            _vm.selectedProduct = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      !_vm.loadingData && _vm.products
        ? _c(
            "div",
            { staticClass: "pa-4 text-center" },
            [
              _c(
                VBtn,
                { staticClass: "ma-2", on: { click: _vm.auditDataIntegrity } },
                [_vm._v(" Audit Data ")]
              ),
              _c("div", { staticClass: "text-caption" }, [
                _vm._v(
                  " Check each row's starting balance plus event changes equals ending balance "
                ),
              ]),
              _vm.console
                ? _c("div", {
                    ref: "console",
                    staticClass: "text-caption pa-5 console text-left",
                    domProps: { innerHTML: _vm._s(_vm.console) },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }